
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/security",
      function () {
        return require("private-next-pages/security.js");
      }
    ]);
  